const STAGING_LINKS = {
  GATE_PASS: "https://staging.vesatogo.com/reports/gatepass/",
  SCHEDULE: "https://staging.vesatogo.com/reports/schedule/",
  PURCHASE_CONDITIONS: "https://staging.vesatogo.com/reports/purchase/",
  INWARD_SLIP: "https://staging.vesatogo.com/reports/inward_slip/",
  BULK_INWARD_SLIP: "https://staging.vesatogo.com/reports/inward_grn_slip/",
  INWARD_SHEET: "https://staging.vesatogo.com/reports/inward_sheet/",
  DETECTION_SHEET: "https://staging.vesatogo.com/reports/detection_sheet/",
  DAILY_INWARD_REPORT:
    "https://staging.vesatogo.com/reports/daily_inward_report/",
  ENGAGEMENT_REPORT: "https://staging.vesatogo.com/reports/engagement/",
  INVOICE: "https://staging.vesatogo.com",
}
const PRODUCTION_LINKS = {
  GATE_PASS: `https://${process.env.REACT_APP_API_HOST}/reports/gatepass/`,
  SCHEDULE: `https://${process.env.REACT_APP_API_HOST}/reports/schedule/`,
  PURCHASE_CONDITIONS: `https://${process.env.REACT_APP_API_HOST}/reports/purchase/`,
  INWARD_SLIP: `https://${process.env.REACT_APP_API_HOST}/reports/inward_slip/`,
  BULK_INWARD_SLIP: `https://${process.env.REACT_APP_API_HOST}/reports/inward_grn_slip/`,
  INWARD_SHEET: `https://${process.env.REACT_APP_API_HOST}/reports/inward_sheet/`,
  DETECTION_SHEET: `https://${process.env.REACT_APP_API_HOST}/reports/detection_sheet/`,
  DAILY_INWARD_REPORT: `https://${process.env.REACT_APP_API_HOST}/reports/daily_inward_report/`,
  ENGAGEMENT_REPORT: `https://${process.env.REACT_APP_API_HOST}/reports/engagement/`,
  INVOICE: "https://herd.vesatogo.com",
}

const getLinks = () => {
  if (process.env.REACT_APP_ENV === "production") {
    return PRODUCTION_LINKS
  }
  return STAGING_LINKS
}

export default getLinks()
